import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import { useAttrs } from "vue";
import { Input } from "@/components/ui/input";


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'RenewalDateInput',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const attrs = useAttrs();



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Input), _mergeProps(_unref(attrs), {
      "model-value": __props.modelValue,
      class: "appearance-none",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
    }), null, 16, ["model-value"])
  ]))
}
}

})